<template>
  <div class="banner_img">
    <img src="../../assets/bannertop.jpg" alt />
    <div class="personal_info">
      <img :src="iteminfo.space_avatar" v-if="iteminfo.space_avatar != '' && iteminfo.space_avatar != ' '"/>
      <img src="../../assets/photoico.png" v-else/>
      <div class="info_self">
        <span class="sex">
          <i :class="UserInfo.sex==='1'?'el-icon-male':'el-icon-female'" :style="UserInfo.sex==='1'?'color:#0d94ff;font-weight: 700;':'color:#ff2c36;font-weight: 700;'"></i>
        </span>
        <span class="name">{{iteminfo.space_name}}</span>
        <span class="identity">
          <el-tag type="success" effect="dark" size="small" v-for="(item1,index) in userType" :key="index" v-show="item1.id == iteminfo.space_type">{{item1.identity}}空间</el-tag>
        </span>
      </div>
      <p class="gexing" v-if="iteminfo.space_brief">{{iteminfo.space_brief}}</p>
      <p class="gexing" v-else>这位老师有点懒!</p>
    </div>
  </div>
</template>


<script>
import VueEvent from '../../api/eventBus'
export default {
  data() {
    return {
      // 用户信息
      UserInfo: '',
      getSpaceinfo:'',
      iteminfo:{},
      space_avatar: false,
      userType:[
        {id:'0000',identity:"普通"},
        {id:'0001',identity:"学生"},
        {id:'0002',identity:"教师"},
        {id:'0003',identity:"校长"},
        {id:'0004',identity:"家长"},
        {id:'0101',identity:"官方"},
        {id:'00FF',identity:"其他"},
        {id:'0100',identity:"机构/工作室"},
        {id:'0102',identity:"教育局"},
        {id:'0103',identity:"学校"},
        {id:'0104',identity:"班级"},
        {id:'0105',identity:"名师"},
        {id:'0106',identity:"学科"},
        {id:'0107',identity:"专题"},
        {id:'01FF',identity:"其他"},
      ]
    };
  },
  created() {

  },
  mounted(){
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.getSpaceinfo = JSON.parse(window.localStorage.getItem("getSpaceinfo"));
    var _this=this
    VueEvent.$off('ziliao')
    VueEvent.$on('ziliao', function(data){
      _this.iteminfo = data
    })
  },
  methods: {}
};
</script>


<style lang="less">
.banner_img {
  width: 100%;
  position: relative;
  text-align: center;

  img {
    width: 100%;
    display: block;
  }
  .personal_info {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 136px;
      height: 136px;
      display: block;
      border-radius: 50%;
    }
    .info_self {
      padding: 10px 0;
      font-size: 24px;

      .name {
        padding: 0 8px;
      }
    }
    p {
      font-size: 14px;
      color: #727272;
    }
    .gexing{
      color: #FFF;
      width: 60%;
      margin: 0 auto;
      overflow: hidden;
      text-overflow: ellipsis;
      display:-webkit-box;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2;
    }
  }
  .el-tag--dark.el-tag--success {
    background-color: #409EFF;
    border-color: #409EFF;
  }
}
</style>